<template>
  <div class="home-page login-content" style="padding-top: 0;">
    <div class="">
      <div class="login login-send">
        <div class="">
          <div class="home-prize">
            <div class="home1">
              <div class="pt20">
                <a class="logo" style="text-align: left;margin: 0 20px -80px;position: relative;" href="/"><img
                  src="static/images/logo.png"/></a>
              </div>
              <div class="disflex " style="justify-content: flex-end;">
                <div class="lang-top" @click="getLan('language')">
                  <img width="30" src="../../static/images/en.png"/>
                </div>
              </div>

              <img width="100%" src="../../static/images/send.jpg"/>
            </div>
          </div>
          <div class="input-div" style="margin-top: -2rem;position: relative;z-index: 10;">
            <div class="fs50 crfff mt30" style="width: 90%;margin:0 auto" v-html="$t('Login')"></div>
            <div class="span mt30 fs33 crfff fw7" style="font-weight: 400;margin-bottom: 15px;">{{ $t('loginTips') }}
            </div>
            <div class="input-item mt50">
              <div class="input-item2 ">
                <span class="app-en" style="height: 0.8rem;border-radius: 1rem;line-height:0.8rem;font-size: 0.3rem;font-weight: 700">+998</span>
                <input class="input" v-model="mobile" type="number" placeholder="">
              </div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" @click="goLogin">{{ $t('get_sms_code') }}</button>
          </div>
          <div class="login_tip" v-html="$t('login_tip')"></div>
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" style="width: 95%;" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
        <div class="information mt100 crfff ac por">
          <div class="fs50">{{ $t('language') }}</div>
          <div class="fs26 mt30 cr0062ff">{{ $t('languageTips') }} :</div>
          <div class="change-list change-list2 ac">
            <div class="one"  @click="getLang(2,'en')" :class="{'active':isShowLang=='en'}">
              <img class="dui" src="../../static/images/dui.png">
              <img style="width:1.2rem"
                   :src="isShowLang=='en'?'../../static/images/en.jpg':'../../static/images/en.jpg'"/>
              <span>{{ $t('lang_1') }}</span>
            </div>
            <div class="one" @click="getLang(2,'bur')" :class="{'active':isShowLang=='bur'}">
              <img class="dui" src="../../static/images/dui.png">
              <img style="width:1.2rem"
                   :src="isShowLang=='bur'?'../../static/images/en1.jpg':'../../static/images/en1.jpg'"/>
              <span>{{ $t('lang_2') }}</span>
            </div>
            <div class="one"  @click="getLang(2,'wz')" :class="{'active':isShowLang=='wz'}">
              <img class="dui" src="../../static/images/dui.png">
              <img style="width:1.2rem"
                   :src="isShowLang=='wz'?'../../static/images/en2.png':'../../static/images/en2.png'"/>
              <span>{{ $t('lang_3') }}</span>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" @click="getLang(1)">{{ $t('change') }}</button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/HeaderTwo'
import Dialog from "../components/dialog.vue";

export default {
  components: {
    Dialog,
    Header
  },
  data() {
    return {
      list: [],
      mobile: '',
      password: '',
      isShowLang: 'wz',
      lang: '',

    }
  },
  created() {
    if(localStorage.getItem('lang')){
      this.isShowLang = localStorage.getItem('lang')
    }
    if (this.$route.query.msisdn) {
      this.mobile = this.dealPhone_2(this.$route.query.msisdn)
    }
  },
  methods: {
    getLan(){
      let that = this
      that.$refs.imgDialog.showMaskFun();
    },
    closeTmgDialog(){
      this.$refs.imgDialog.closeMask();
    },
    getLang(type,lang){
      if(type==1){
        localStorage.setItem('lang',this.lang)
        location.reload()
      }else{
        this.isShowLang = lang
        this.lang = lang
      }
    },
    getType(type) {
      this.$router.push({path: '/' + type, query: {type: type}});
    },
    back() {
      this.$router.go(-1);
    },

    goLogin() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = '998'+this.mobile
      var code = this.$route.query.code
      let data = {
        'mobile': mobile,
      }
      that.$parent.loadModal(true);
      //检测号码
      that.$api.post('/api/user/check_user', data, r => {
        if (r.code == 1) {
          that.$parent.loadModal(false);
          localStorage.setItem('token', r.data.userinfo.token)
          localStorage.setItem('mobile', r.data.userinfo.mobile)
          that.isShowlogin = false
          that.mobile = ''
          this.$router.push({path: '/'})
        } else if (r.code == -1) {
          window.location.href = r.data.cg_url
        } else {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 100, 3000);
        }
      })

    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('998')) {
        phone = phone.substring(3);
      }
      return phone;
    },
  }
}
</script>
<style scoped>
.drop-down-content {
  z-index: 9;
  background: none;
}

.mt100 {
  margin-top: 100px;
}

.otp-b {
  justify-content: space-evenly;
}
</style>



// WEBPACK FOOTER //
// src/page/LoginNew.vue